const BASE_COOKIE_NAME = 'sabi-damu'

export const COOKIE_KEY = {
  ACCESS_TOKEN: `${BASE_COOKIE_NAME}-jwt`,
  REFRESH_TOKEN: `${BASE_COOKIE_NAME}-refresh`,
  IS_SCREENING: `${BASE_COOKIE_NAME}-screening`,
  LANG: `${BASE_COOKIE_NAME}-lang`,
  EMBED: `${BASE_COOKIE_NAME}-embed`,
  THEMES: `${BASE_COOKIE_NAME}-themes`,
} as const